import { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import styles from '../../assets/scss/layout/Header.module.scss';
import logo from '../../assets/img/logo.png';
import MobileMenu from './MobileMenu';

const cx = (...keys) => keys.filter(Boolean).map((k) => styles[k] || k).join(' ');

export default function Header() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const isHome = pathname === '/' || pathname === '/trang-chu';
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userData = localStorage.getItem('user');
        if (token && userData) {
            try {
                const parsedUser = JSON.parse(userData);
                if (parsedUser.role === 'superadmin') {
                    setIsLoggedIn(true);
                }
            } catch (e) {
                console.error('Error parsing user data:', e);
            }
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setIsLoggedIn(false);
        navigate('/navo-admin/login');
    };

    const scrollToTop = (smooth) => {
        const behavior = smooth ? 'smooth' : 'auto';
        // Phần tử cuộn thực tế của app là #root (do html/body/#root đặt height:100%
        // + overflow-x:hidden → #root tự thành vùng cuộn dọc), nên window.scrollTo
        // không có tác dụng. Cuộn cả #root lẫn window để chắc chắn.
        document.getElementById('root')?.scrollTo({ top: 0, behavior });
        window.scrollTo({ top: 0, behavior });
    };

    const handleLogoClick = (e) => {
        if (isHome) {
            // Đang ở trang chủ: chỉ cuộn lên đầu (URL không đổi nên không cần điều hướng).
            e.preventDefault();
            scrollToTop(true);
        } else {
            // Từ trang khác về trang chủ rồi đảm bảo nằm ở đầu trang.
            scrollToTop(false);
        }
    };

    return (
        <header className={cx('header')}>
            <NavLink to="/trang-chu" className={cx('header__logo')} onClick={handleLogoClick}>
                <img className={cx('header__logo-img')} src={logo} alt="Navo Sổ Tiệm" />
                <span className={cx('header__logo-title')}>Navo Sổ Tiệm</span>
            </NavLink>

            <nav className={cx('header__nav', 'header__nav--center')}>
                {isHome ? (
                    <>
                        <a className={cx('header__link')} href="#features">Tính năng</a>
                        <a className={cx('header__link')} href="#pricing">Bảng giá</a>
                        <a className={cx('header__link')} href="#contact">Liên hệ</a>
                        <a className={cx('header__link')} href="#faq">Câu hỏi</a>
                    </>
                ) : (
                    <>
                        <NavLink to="/trang-chu" className={cx('header__link')}>Trang chủ</NavLink>
                        <NavLink to="/chinh-sach-bao-mat" className={cx('header__link')}>Chính sách bảo mật</NavLink>
                    </>
                )}
            </nav>

            <div className={cx('header__actions', 'header__nav--desktop')}>
                {isLoggedIn ? (
                    <>
                        <NavLink to="/navo-admin/dashboard" className={cx('header__link')}>Dashboard</NavLink>
                        <button onClick={handleLogout} className={cx('header__btn', 'header__btn--ghost')}>Đăng xuất</button>
                    </>
                ) : (
                    <>
                        <NavLink to="/admin/login" className={cx('header__btn', 'header__btn--ghost')}>Đăng nhập</NavLink>
                        <NavLink to="/admin/register" className={cx('header__btn', 'header__btn--primary')}>
                            <i className="fa-solid fa-bolt"></i>Dùng thử miễn phí
                        </NavLink>
                    </>
                )}
            </div>

            <MobileMenu />
        </header>
    );
}
